export default __webpack_public_path__ + "static/media/authentication-corner.f8e7f312.png";